import { createEventTracker, createV2EventTracker } from '../util';
import {
  AISummaryFeedback,
  AISummaryRequested,
  AISummaryUsed,
  RendererLoadSucceeded,
  RendererLoadError,
  RendererLoadPerformance,
  RendererSeekError,
  RendererPlayError,
  RendererPlayPerformance,
  RendererPlaySucceeded,
  ReplayPausedAnalytics,
  ReplayPlayedAnalytics,
  ReplaySeekedBackwardAnalytics,
  ReplaySeekedForwardAnalytics,
  RendererSeekSample,
} from './types';

export const trackReplayPaused = createEventTracker<ReplayPausedAnalytics>('Replay Paused');
export const trackReplayPlayed = createEventTracker<ReplayPlayedAnalytics>('Replay Played');
export const trackReplaySeekedForward =
  createEventTracker<ReplaySeekedForwardAnalytics>('Replay Seeked Forward');
export const trackReplaySeekedBackward =
  createEventTracker<ReplaySeekedBackwardAnalytics>('Replay Seeked Backward');
export const trackAISummaryRequested =
  createEventTracker<AISummaryRequested>('AI Summary Requested');
export const trackAISummaryUsed = createEventTracker<AISummaryUsed>('AI Summary Used');
export const trackAISummaryFeedback = createEventTracker<AISummaryFeedback>('AI Summary Feedback');
export const trackRendererLoadSucceeded =
  createV2EventTracker<RendererLoadSucceeded>('Renderer Load Succeeded');
export const trackRendererLoadError =
  createV2EventTracker<RendererLoadError>('Renderer Load Error');
export const trackRendererLoadPerformance = createV2EventTracker<RendererLoadPerformance>(
  'Renderer Load Performance',
);
export const trackRendererSeekError =
  createV2EventTracker<RendererSeekError>('Renderer Seek Error');
export const trackRendererSeekSample =
  createV2EventTracker<RendererSeekSample>('Renderer Seek Sample');
export const trackRendererPlaySucceeded =
  createV2EventTracker<RendererPlaySucceeded>('Renderer Play Succeeded');
export const trackRendererPlayError =
  createV2EventTracker<RendererPlayError>('Renderer Play Error');
export const trackRendererPlayPerformance = createV2EventTracker<RendererPlayPerformance>(
  'Renderer Play Performance',
);
